// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"Content2Page_contentContainer__24QoQ"};